// GALLERY
function gbbSelectMedia(index, sid) {
  document.querySelectorAll('#gbb-slides-' + sid + ' .gbb-gallery__slide').forEach(function(el) { el.classList.remove('is-active'); });
  document.querySelectorAll('.gbb-gallery__thumb').forEach(function(el) { el.classList.remove('is-active'); });
  document.querySelectorAll('#gbb-dots-' + sid + ' .gbb-gallery__dot').forEach(function(el) { el.classList.remove('is-active'); });
  var slide = document.querySelector('#gbb-slides-' + sid + ' .gbb-gallery__slide[data-index="' + index + '"]');
  var thumb = document.querySelector('.gbb-gallery__thumb[data-index="' + index + '"]');
  var dot = document.querySelector('#gbb-dots-' + sid + ' .gbb-gallery__dot[data-index="' + index + '"]');
  if (slide) slide.classList.add('is-active');
  if (thumb) thumb.classList.add('is-active');
  if (dot) dot.classList.add('is-active');
  window['gbbCurrentIndex_' + sid] = index;
}

function gbbSlide(dir, sid) {
  var slides = document.querySelectorAll('#gbb-slides-' + sid + ' .gbb-gallery__slide');
  var total = slides.length;
  var current = window['gbbCurrentIndex_' + sid] || 0;
  var next = (current + dir + total) % total;
  gbbSelectMedia(next, sid);
}

// QTY
function gbbQty(change, sid) {
  var input = document.getElementById('gbb-qty-' + sid);
  var hidden = document.getElementById('gbb-qty-hidden-' + sid);
  if (!input) return;
  var newVal = Math.max(1, parseInt(input.value) + change);
  input.value = newVal;
  if (hidden) hidden.value = newVal;
}

// VARIANT UPDATE
function gbbUpdateVariant(sid) {
  var dataEl = document.getElementById('gbb-product-data-' + sid);
  if (!dataEl) return;
  var productData = JSON.parse(dataEl.textContent);
  var selectedOptions = [];
  var optionEls = document.querySelectorAll('#gbb-info-' + sid + ' .gbb-option');
  optionEls.forEach(function(optionEl) {
    var checked = optionEl.querySelector('.gbb-variant-input:checked');
    if (checked) selectedOptions.push(checked.value);
  });
  var matched = null;
  for (var v = 0; v < productData.variants.length; v++) {
    if (productData.variants[v].options.join('||') === selectedOptions.join('||')) {
      matched = productData.variants[v];
      break;
    }
  }
  if (!matched) return;

  // Update variant id
  var vidInput = document.getElementById('gbb-variant-id-' + sid);
  if (vidInput) vidInput.value = matched.id;

  // Update price using Shopify.formatMoney
  var priceEl = document.getElementById('gbb-price-' + sid);
  var compareEl = document.getElementById('gbb-compare-' + sid);
  if (priceEl && window.Shopify && Shopify.formatMoney) {
    priceEl.textContent = Shopify.formatMoney(matched.price, productData.money_format);
  }
  if (compareEl) {
    if (matched.compare_at_price > matched.price) {
      if (window.Shopify && Shopify.formatMoney) {
        compareEl.textContent = Shopify.formatMoney(matched.compare_at_price, productData.money_format);
      }
      compareEl.style.display = '';
      if (priceEl) priceEl.classList.add('gbb-price--sale');
    } else {
      compareEl.style.display = 'none';
      if (priceEl) priceEl.classList.remove('gbb-price--sale');
    }
  }

  // Update ATC button
  var atcBtn = document.getElementById('gbb-atc-btn-' + sid);
  if (atcBtn) {
    var atcLabel = atcBtn.getAttribute('data-atc-label') || 'Add to Cart';
    var soldLabel = atcBtn.getAttribute('data-sold-label') || 'Sold Out';
    if (matched.available) {
      atcBtn.disabled = false;
      atcBtn.classList.remove('gbb-atc-btn--sold-out');
      atcBtn.textContent = atcLabel;
    } else {
      atcBtn.disabled = true;
      atcBtn.classList.add('gbb-atc-btn--sold-out');
      atcBtn.textContent = soldLabel;
    }
  }

  // Update active swatch states
  document.querySelectorAll('#gbb-info-' + sid + ' .gbb-variant-opt, #gbb-info-' + sid + ' .gbb-pill-opt').forEach(function(opt) {
    opt.classList.remove('is-active');
  });
  document.querySelectorAll('#gbb-info-' + sid + ' .gbb-variant-input:checked').forEach(function(input) {
    var label = input.closest('.gbb-variant-opt, .gbb-pill-opt');
    if (label) label.classList.add('is-active');
  });

  // Update selected value labels
  document.querySelectorAll('#gbb-info-' + sid + ' .gbb-option').forEach(function(optEl, i) {
    var span = optEl.querySelector('.gbb-option__selected');
    if (span && matched.options[i]) span.textContent = matched.options[i];
  });

  // Switch gallery image
  if (matched.featured_image && matched.featured_image.position) {
    gbbSelectMedia(matched.featured_image.position - 1, sid);
  }
}

// VIDEO
function gbbOpenVideo(src, sid) {
  var modal = document.getElementById('gbb-video-modal-' + sid);
  var player = document.getElementById('gbb-video-player-' + sid);
  if (modal && player) {
    player.src = src;
    modal.classList.add('is-open');
    player.play().catch(function() {});
  }
}
function gbbCloseVideo(sid) {
  var modal = document.getElementById('gbb-video-modal-' + sid);
  var player = document.getElementById('gbb-video-player-' + sid);
  if (modal) modal.classList.remove('is-open');
  if (player) { player.pause(); player.src = ''; }
}

// AJAX ATC
function gbbAddToCart(e, sid) {
  e.preventDefault();
  var variantId = document.getElementById('gbb-variant-id-' + sid).value;
  var qtyEl = document.getElementById('gbb-qty-hidden-' + sid);
  var qty = qtyEl ? parseInt(qtyEl.value) : 1;
  var btn = document.getElementById('gbb-atc-btn-' + sid);
  var originalText = btn ? btn.textContent.trim() : 'Add to Cart';
  if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('failed');
    return res.json();
  })
  .then(function() {
    if (btn) { btn.textContent = originalText; btn.disabled = false; }

    // Refresh cart count AND minicart HTML
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count,.cart__count,.cart-item-count,.js-number-cart,.enj-cartcount,.enj-minicart-count,.cart-counter').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        return fetch('/cart?view=minicart-ajax');
      })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newContent = doc.querySelector('.mini-cart-bottom');
        var currentContent = document.querySelector('.mini-cart-bottom.enj-minicart-ajax');
        if (newContent && currentContent) {
          currentContent.innerHTML = newContent.innerHTML;
        }
      })
      .catch(function() {});

      // Open minicart
    var triggers = [
      '.js-call-minicart',
      'a.js-call-minicart',
      '.btn-addToCart',
      '.shop-button.addcart-link',
      '[data-cart-toggle]',
      '[data-cart-drawer-toggle]',
      '#cart-icon-bubble'
    ];
    setTimeout(function() {
      var opened = false;
      triggers.forEach(function(sel) {
        if (!opened) { var el = document.querySelector(sel); if (el) { el.click(); opened = true; } }
      });
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }, 800);
  })
  .catch(function() {
    if (btn) { btn.textContent = originalText; btn.disabled = false; }
  });
  // Hide sticky bar when cart opens
document.querySelectorAll('.gbb-sticky-atc').forEach(function(bar) {
  bar.classList.remove('is-visible');
});
}

// STICKY ATC
document.addEventListener('DOMContentLoaded', function() {
  var atcWrap = document.querySelector('.gbb-atc-wrap');
  var stickyBars = document.querySelectorAll('.gbb-sticky-atc');
  if (!atcWrap || !stickyBars.length) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      stickyBars.forEach(function(bar) {
        if (!entry.isIntersecting) { bar.classList.add('is-visible'); }
        else { bar.classList.remove('is-visible'); }
      });
    });
  }, { threshold: 0 });
  observer.observe(atcWrap);
});
